module.exports = __webpack_public_path__ + "img/desarrollo_web.08b7e854.png";